module.exports = __webpack_public_path__ + "assets/img/small_brand_icon.67e8e2e2.svg";